import { strings } from '..';
import { IconValues } from './models';

export function datetimeFormatter(value: string | number | Date) {
    const locale = strings.getLanguage();
    const options: Intl.DateTimeFormatOptions = { 
        year: 'numeric', 
        month: '2-digit', 
        day: '2-digit' 
    };

    return new Date(value).toLocaleDateString(locale, options);
}

export function getIconName(fileName: string): IconValues {
    if (fileName === undefined) {
        throw new Error("fileName non può essere undefined");
    }

    const splitted = fileName.split('.');
    const element = splitted.pop();
    const extension = element === undefined ? '' : element.toLowerCase();

    switch (extension) {
        case "pdf": return { name: "file pdf outline", color: "red" };

        case "doc": return { name: "file word outline", color: "blue" };
        case "docx": return { name: "file word outline", color: "blue" };

        case "xls": return { name: "file excel outline", color: "green" };
        case "xlsx": return { name: "file excel outline", color: "green" };
        
        case "msg": return { name: "mail outline", color: "green" };

        case "txt": return { name: "file alternate outline", color: "grey" };

        case "jpg": return { name: "file image outline", color: "yellow" };
        case "jpeg": return { name: "file image outline", color: "yellow" };
        case "png": return { name: "file image outline", color: "yellow" };
        case "bmp": return { name: "file image outline", color: "yellow" };

        default: return { name: "file outline", color: "black" };
    }
}

export function decimalFormatter(value: number) {        
    const locale = strings.getLanguage();
    return Intl.NumberFormat(locale, { minimumFractionDigits: 2 }).format(value)
}